<template>
  <div class="lt">
    <div class="lt-bottom">
      <div class="lt-bt-item" v-for="(item, index) in defaultdata" :key="index">
        <div class="lt-item-content">
          <img src="../../assets/template3/btimg.png" alt="" class="bt-bg-img" />
          <div class="item-num" >{{ item.value2 }}</div>
          <div class="lt-item-title">{{ item.value1 + '(' + item.value3 + ')' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'template.scope9',
  data() {
    return {
      // name描述 val蓝色字体 unit白色字体
      defaultdata: [
        { value1: "国有林地", value2: '414', value3: "亩" },
        { value1: "基本农田", value2: '414', value3: "亩" },
        { value1: "一般耕地", value2: '414', value3: "亩" },
        { value1: "林地", value2: '414', value3: "亩" },
        { value1: "商业用地", value2: '414', value3: "亩" },
        { value1: "总面积", value2: '414', value3: "公顷" },
        { value1: "建设用地", value2: '414', value3: "亩" },
        { value1: "闲置土地", value2: '414', value3: "亩" },
      ],
      valueMap: [
        { name: '名称', key: "value1" },
        { name: '数值', key: "value2" },
        { name: '单位', key: "value3" },
      ]
    };
  },
  watch: {},
  methods: {
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Benmo-Ziyu";
  src: url("../../assets/fonts/Benmo-Ziyu.woff2");
}

.lt {
  width: 435px;
  height: 240px;
  display: flex;
  padding: 10px 0;
  position: relative;
}

.lt-bottom {
  display: flex;
  flex-wrap: wrap;
  margin-left: 20px;
}

.lt-bt-item {
  width: 100px;
  height: 100px;
  position: relative;
  margin: -26px 0 0;
  display: flex;
  // flex-direction: column;
}

.lt-bt-item:nth-child(4n + 1) {
  margin-left: 0;
}

.bt-bg-img {
  // position: absolute;
  width: 94px;
  height: 115px;
}

.bt-icon {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 36px;
  top: 20px;
}

.lt-item-title {
  margin: 46px 0 0 18px;
  width: 83px;
  height: 15px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #70ADAC;
  line-height: 15px;
}

.item-num {
  margin: -58px 0 0 26px;
  width: 46px;
  height: 19px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 25px;
  color: #FFFFFF;
  line-height: 15px;

}

.item-val {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #AFC2DF;
  line-height: 19px;
}

.item-value3 {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #a6bbd9;
  line-height: 19px;
  margin-left: 4px;
}
</style>